<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('preInvoice.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('preInvoice.pageTitle'),
          href: '/pre-invoices'
        },
        {
          text: $t('approve'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row form-group">
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('preInvoice.studentInfo') }}</legend>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.cardNumber')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly type="text" class="form-control-plaintext" :value="show_data.card_number" />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.studentName')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.full_name_en" />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.sex')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.gender" />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.dateOfBirth')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.date_of_birth" />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.phone')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.phone" />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.batch')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.promotion" />
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('preInvoice.academic') }}</legend>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.mainProgram')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.main_program
                        ? show_data.main_program.acp_name_foreign
                        : ''
                        " />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.subProgram')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.sub_program
                        ? show_data.sub_program.acps_name_foreign
                        : ''
                        " />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.level')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.grade
                        ? show_data.grade.level.level_name_foreign
                        : ''
                        " />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.year')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.year" />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.semester')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.semester" />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('preInvoice.gradeName')
                    }}</label>
                    <div class="col-md-9">
                      <input readonly class="form-control-plaintext" :value="show_data.grade
                        ? show_data.grade.grade_name_foreign
                        : ''
                        " />
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12">
              <panel :title="$t('preInvoice.item')">
                <div class="overflow-auto">
                  <div id="list-container">
                    <table class="table ui-table ts-table" style="min-width:1570px">
                      <thead>
                        <tr>
                          <th style="width:250px">
                            {{ $t('paymentNotice.feeType') }}
                          </th>
                          <th style="width:250px">
                            {{ $t('paymentNotice.feeName') }}
                          </th>
                          <th style="width:250px">
                            {{ $t('paymentNotice.description') }}
                          </th>
                          <th style="width:100px">
                            {{ $t('paymentNotice.startDate') }}
                          </th>
                          <th style="width:100px">
                            {{ $t('paymentNotice.startDate') }}
                          </th>
                          <th style="width:110px" class="text-center">
                            {{ $t('paymentNotice.qty') }}
                          </th>
                          <th style="width:110px" class="text-center">
                            {{ $t('paymentNotice.fee') }}
                          </th>
                          <th style="width:120px" class="text-center">
                            {{ $t('paymentNotice.discount') }}
                          </th>
                          <th style="width:110px" class="text-center">
                            {{ $t('paymentNotice.vat') }}
                          </th>
                          <th style="width:110px">
                            {{ $t('paymentNotice.amount') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in show_data.pre_invoice_detail" :key="index">
                          <td>{{ item.fee_type.fee_type_name }}</td>
                          <td>{{ item.fee_setup.fee_name_en }}</td>
                          <td>{{ item.fee_description }}</td>
                          <td>{{ item.fee_start_date }}</td>
                          <td>{{ item.fee_end_date }}</td>
                          <td class="text-center">{{ item.quantity }}</td>
                          <td class="text-center">{{ item.fee_amount }}</td>
                          <td class="text-center">{{ item.discount_rate }}</td>
                          <td class="text-center">{{ item.vat_rate }}</td>
                          <td class="text-right">{{ roundUpTotal(item.total_amount) }}</td>
                        </tr>
                        <!-- <tr>
                          <td colspan="9" class="text-right">
                            <strong>{{ $t('preInvoice.total') }}</strong>
                          </td>
                          <td class="text-right">
                            <strong
                              ><u>{{ show_data.total_amount }}</u></strong
                            >
                          </td>
                        </tr> -->
                        <tr>
                          <td colspan="10" class="text-right" valign="top">
                            <div class="ts-p-2 ts-rounded ts-space-y-2 ts-inline-block ts-text-left"
                              style="min-width: 300px;">

                              <div class="ts-space-y-1">
                                <p class="ts-bg-red-100 ts-text-red-500 ts-py-1 ts-px-2 ts-rounded"
                                  style="width: fit-content;">
                                  {{ $t('paymentNotice.subTotal') }}
                                </p>
                                <a-input :value="withDefaultCurrency(model.total_amount)" disabled></a-input>
                              </div>

                              <div class="ts-space-y-1">
                                <p class="ts-bg-gray-100 ts-text-gray-600 ts-py-1 ts-px-2 ts-rounded"
                                  style="width: fit-content;">
                                  {{ $t('paymentNotice.discount') }}
                                </p>
                                <div class="ts-flex ts-items-center ts-border ts-rounded ts-w-full ts-p-1">
                                  <select v-model="model.discount_type" @change="calculate"
                                    class="focus:ts-outline-none ts-px-3 ts-rounded">
                                    <option value="%">%</option>
                                    <option value="$">$</option>
                                  </select>
                                  <input type="number" step="any"
                                    class="ts-w-full ts-py-1 focus:ts-outline-none ts-ml-2"
                                    v-model.number="model.discount_value" @input="calculate" />
                                </div>
                              </div>

                              <div class="ts-space-y-1">
                                <p class="ts-bg-gray-100 ts-text-gray-600 ts-py-1 ts-px-2 ts-rounded"
                                  style="width: fit-content;">
                                  {{ $t('paymentNotice.grandTotal') }}
                                </p>
                                <a-input :value="withDefaultCurrency(model.total_amount - model.discounted_amount)"
                                  disabled></a-input>
                              </div>

                            </div>
                          </td>
                        </tr>
                        <tr height="24"></tr>
                        <tr class="bb">
                          <td colspan="10" valign="top" class="ts-text-right">
                            <div style="width: 400px" class="ts-float-right ts-space-y-3">
                              <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                                <div class="ts-flex ts-items-center ts-justify-end">
                                  <label>{{ $t('invoice.paymentMethod') }}
                                    <span class="text-danger">*</span></label>
                                </div>
                                <div class="ts-col-span-2 ts-pl-4">
                                  <select class="form-control" v-model="model.payment_method_id"
                                    @change="onPaymentMethodChange" :disabled="show_data.is_approved == 1">
                                    <option value="">--select--</option>
                                    <option v-for="(p, index) in paymentMethods" :key="index" :value="p.id">{{ p.label
                                    }}</option>
                                  </select>
                                  <div class="validate" v-if="errors.has('data.payment_method_id')">
                                    {{ errors.first('data.payment_method_id') }}
                                  </div>
                                </div>
                              </div>
                              <div class="ts-grid ts-grid-cols-3 ts-gap-3" v-show="model.payment_method_id == 2 ||
                                model.payment_method_id == 3 ||
                                model.payment_method_id == 4
                                ">
                                <div class="ts-flex ts-items-center ts-justify-end">
                                  <label>{{ $t('invoice.bankName') }}
                                    <span class="text-danger" v-show="model.payment_method_id != 1">*</span></label>
                                </div>
                                <div class="ts-col-span-2 ts-pl-4">
                                  <select v-model="model.bank_id" class="form-control"
                                    :disabled="show_data.is_approved == 1">
                                    <option v-for="(b, index) in banks" :value="b.bank_id" :key="index">{{ b.bank_name
                                    }}</option>
                                  </select>
                                  <div class="validate" v-if="errors.has('data.bank_id')">
                                    {{ errors.first('data.bank_id') }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </panel>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button @click="$router.push({ name: 'pre-invoice' })">{{
                $t('close')
              }}</ts-button>
              <ts-button v-show="show_data.is_approved == 0" :waiting="approving" @click.prevent="onApprove"
                color="primary" class="ml-2">{{ $t('approve') }}</ts-button>
            </div>
          </div>
          <pdf-preview v-model="pdf_view" :invoice-id="invoiceId" @cancel="$router.push({ name: 'invoice' })" />
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import PdfPreview from '../../official-receipts/views/components/pdf_preview.vue'
import { clone, round, sumBy } from 'lodash'

export default {
  name: 'preInvoiceApprove',
  components: { PdfPreview },
  data() {
    return {
      approving: false,
      loading: false,
      pdf_view: false,
      errors: new Errors(),
      model: {
        payment_method_id: undefined,
        inv_id: '',
        card_number: '',
        full_name_en: '',
        gender: '',
        date_of_birth: '',
        phone: '',
        promotion: '',
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_id: '',
        year: '',
        semester: '',
        total_amount: 0,
        bank_id: '',
        pre_invoice_detail: [],
        discount_value: 0,
        discounted_amount: 0,
        discount_type: '%',

      },
      invoiceId: 0,
      banks: [],
      show_data: {},
      defaultCurrency: { currency_code: 'USD' }
    }
  },
  computed: {
    paymentMethods() {
      return [
        { id: 1, label: 'Cash' },
        { id: 2, label: 'Bank QR' },
        { id: 3, label: 'Bank Transfer' },
        { id: 4, label: 'Credit Card' }
      ]
    }
  },
  created() {
    this.setEditData()
    this.fetchBankProfile()
  },
  methods: {
    ...mapActions('paymentNoticeModule', ['onGetBank']),
    fetchBankProfile() {
      this.onGetBank().then(response => {
        this.banks = response.data.data
      })
    },
    onApprove() {
      this.errors = new Errors()
      this.approving = true
      this.$store
        .dispatch('paymentNoticeModule/onApprove', this.model)
        .then(response => {
          this.$toasted.success(response.data.message)
          this.invoiceId = response.data.id
          if (this.invoiceId > 0) {
            this.pdf_view = true
          }
        })
        .catch(error => {
          this.$toasted.error(error.response.data.message)
          this.errors = new Errors(error.response.data.errors)
        })
        .finally(() => {
          this.approving = false
        })
    },
    async setEditData() {
      this.loading = true
      await this.$store
        .dispatch('paymentNoticeModule/onShowRecord', this.$route.params.id)
        .then(response => {
          this.show_data = response.data.data
          this.errors = new Errors()
          this.model = {
            inv_id: this.show_data.inv_id,
            card_number: this.show_data.card_number,
            full_name_en: this.show_data.full_name_en,
            gender: this.show_data.gender,
            date_of_birth: this.show_data.date_of_birth,
            phone: this.show_data.phone,
            promotion: this.show_data.promotion,
            acp_id: this.show_data.acp_id,
            acps_id: this.show_data.acps_id,
            level_id: this.show_data.level_id,
            grade_id: this.show_data.grade_id,
            year: this.show_data.year,
            semester: this.show_data.semester,
            total_amount: this.show_data.total_amount,
            payment_method_id: '',
            bank_id: this.show_data.bank_id,
            pre_invoice_detail: clone(this.show_data.pre_invoice_detail),
            discount_value: this.show_data.discount_value || 0,
            discount_type: this.show_data.discount_type || '%',
            discounted_amount: 0,
            grand_total: 0
          }
          this.calculate()
        })
        .finally(() => (this.loading = false))
    },
    onPaymentMethodChange() {
      if (this.model.payment_method_id == 1) {
        this.model.bank_id = null
      }
    },
    pushBack() {
      this.$router.push({ name: 'pre-invoice' })
    },
    roundUpTotal(value) {
      if (!value && value !== 0) return 0
      return Math.ceil(value)
    },
    withDefaultCurrency(value) {
      if (!value && value !== 0) return ''
      const defCurrency = this.defaultCurrency
      if (defCurrency) {
        return `${defCurrency.currency_code} ${value.toLocaleString('en-US')}`
      }
      return value.toLocaleString('en-US')
    },

    calculate() {
      var price = 0
      if (this.model.pre_invoice_detail.length > 0) {
        this.model.pre_invoice_detail.forEach(detail => {
          detail.quantity = detail.quantity ? detail.quantity : 1
          price = detail.fee_amount ? detail.fee_amount * detail.quantity : 0

          if (detail.discount_type == '%') {
            detail.discount_amount = detail.discount_rate
              ? price * round(detail.discount_rate / 100, 4)
              : 0
          }
          if (detail.discount_type == '$') {
            detail.discount_amount = detail.discount_rate
          }

          detail.total_amount = price - detail.discount_amount
          detail.vat_amount = detail.vat_rate
            ? detail.total_amount * round(detail.vat_rate / 100, 4)
            : 0
          detail.amount_include_vat = round(
            detail.total_amount + detail.vat_amount,
            2
          )
        })

        let sumAmountIncludeVat = sumBy(
          this.model.pre_invoice_detail,
          'amount_include_vat'
        )

        //  Round up SubTotal
        this.model.total_amount = this.roundUpTotal(sumAmountIncludeVat)

        if (this.model.discount_type == '%') {
          this.model.discounted_amount = this.model.total_amount
            ? this.model.total_amount * round(this.model.discount_value / 100, 4)
            : 0
        } else if (this.model.discount_type == '$') {
          this.model.discounted_amount = this.model.discount_value || 0
        } else {
          this.model.discounted_amount = 0
        }
        const grandTotalBeforeRound = this.model.total_amount - this.model.discounted_amount
        this.model.grand_total = this.roundUpTotal(grandTotalBeforeRound)
      }
    },
  }
}
</script>

<style lang="css" scoped>
#list-container {
  white-space: nowrap;
}

.table>thead>tr>th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}

.table>tbody>tr>td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
</style>
